export class EncodingUtils {
  private constructor() {}

  public static utf8ToUtf16LE(str: string): Uint8Array {
    const byteArray = new Uint8Array(str.length * 2);

    for (let i = 0; i < str.length; i++) {
      byteArray[i * 2] = str.charCodeAt(i);
      byteArray[i * 2 + 1] = str.charCodeAt(i) >> 8;
    }

    return byteArray;
  }
}
